import React from 'react';
import UpdatePasswordAccount from 'pages/counselor/account/UpdatePasswordAccount';

const ProfileUpdatePassword = () => {
    return <UpdatePasswordAccount />;
};

export default ProfileUpdatePassword;
